import {
  TERMINAL_RESET_REQUEST,
  TERMINAL_RESET_REQUEST_SUCCESS,
  TERMINAL_RESET_REQUEST_FAILURE,
  TERMINAL_DELETE_REQUEST,
  TERMINAL_DELETE_REQUEST_SUCCESS,
  TERMINAL_DELETE_REQUEST_FAILURE,
  TERMINAL_RESET_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const terminalResetsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_RESET_REQUEST:
    case TERMINAL_DELETE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_RESET_REQUEST_SUCCESS:
    case TERMINAL_DELETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TERMINAL_RESET_REQUEST_FAILURE:
    case TERMINAL_DELETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_RESET_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default terminalResetsReducer;
